import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=5b7b91ab&scoped=true&"
import script from "./FooterComp.vue?vue&type=script&lang=js&"
export * from "./FooterComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=5b7b91ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b91ab",
  null
  
)

export default component.exports